import { axios } from './axios';

export async function checkForExternalAuthRequired(domain:string):Promise<string> {
  const response = await axios.get(`/external_auth_required?domain=${domain}`);

  return response.data?.provider as string;
}
